<template>
  <div>
   <!--  <div class="emergency"></div> -->
    <!-- 表单 -->
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off" class="ant-advanced-search-form">
      <a-row :gutter="10">
        <!-- 关系 -->
        <a-col :xs="24" :lg="4">
          <a-form-item id="emergencyRealationShip" label="Relationship">
            <a-select
              v-decorator="[
                'emergencyContact.realationShip',
                { rules: [{ required: false, message: 'Please select your Relationship!' }] },
              ]"
              placeholder="Please select your Relationship"
            >
              <a-select-option value="">&nbsp;</a-select-option>
              <a-select-option v-for="c in realationShipList" :key="'rsList-' + c.id" :value="c.id">{{ c.rsName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- Last Name -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="Last">
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'emergencyContact.lastName',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input Last Name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- First Name -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="First">
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'emergencyContact.firstName',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input First Name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 邮箱 -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="E-Mail">
            <a-input
              v-decorator="[
                'emergencyContact.email',
                {rules: [{ required: false, type: 'email', message: 'Please enter a email.' }]}
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <!-- 电话 -->
          <a-col :xs="24" :lg="8">
            <a-form-item label="Contact number">
              <div style="display: flex; align-items: center;">
                <PhonenumberInput 
                  v-if="phoneNumberData" 
                  :initData="phoneNumberData" 
                  @update="handlePhoneNumberUpdata"
                  style="flex: 1;"
                />
                <a-input
                  placeholder="Ext."
                  v-decorator="['emergencyContact.phoneExt']"
                  style="width: 70px;border-top-left-radius:0; border-bottom-left-radius:0; margin-left: -3px;"
                />
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="10" style="display:flex;padding-right: 0;">
          <a-col :xs="24" :lg="8" style="padding-right: 0;">
            <a-form-item label="Contact number">
              <PhonenumberInput v-if="phoneNumberData" :initData="phoneNumberData" @update="handlePhoneNumberUpdata"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="2" class="phone-number-extension">
            <a-form-item label=" ">
              <a-input
                placeholder="Ext."
                class="phone-number-extension-input"
                v-decorator="[
                'emergencyContact.phoneExt',
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row> -->
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import _ from 'lodash'
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'
// import { RealationShip } from '@/utils/helper/standard-code-utils'

export default {
  name: 'CdbCustomerContact',
  components: {
    PhonenumberInput
  },
  props: {
    initData: {
      type: Object,
      default: null
    },
    realationShipList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      editForm: this.$form.createForm(this),
      editData: this.initData,
      visible: false,
      phoneNumberData: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      this.phoneNumberData = null
      const vueData = this.editData
      if (vueData) {
        const editData = pick(vueData, ['realationShip', 'firstName', 'lastName', 'email', 'phoneExt'])
        let phoneNumberData = null
        // 处理电话号码
        if (vueData.phoneNumber && vueData.phoneNumber !== '') {
          phoneNumberData = {
            countryCode: vueData.phoneCountryCode ? vueData.phoneCountryCode : 'US',
            countryCallingCode: vueData.phoneCountryCallingCode,
            isValid: false,
            phoneNumber: vueData.phoneNumber
          }
        } else {
            phoneNumberData = {
              countryCode: 'US',
              countryCallingCode: '1',
              isValid: false,
              phoneNumber: ''
            }
        }
        const formData = { emergencyContact: editData }
        this.$nextTick(() => {
          this.editForm.setFieldsValue(formData)
          this.phoneNumberData = phoneNumberData
        })
      }
    },
    // 处理了名字变化
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    // 处理国家区号输入变更
    handlePhoneNumberUpdata (newValue) {
      this.phoneNumberData = newValue
    },
    // 父组件调用校验方法
    validateEmergencyContactForm () {
      const that = this
      const editForm = this.editForm
      const phoneNumberData = that.phoneNumberData
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          if (err) {
            reject()
            return
          }
          // 校验电话号码是否有效
          if (phoneNumberData.phoneNumber && phoneNumberData.phoneNumber !== '' && !phoneNumberData.isValid) {
            reject()
            return
          }
          var formData = editForm.getFieldsValue()
          formData = formData.emergencyContact
          formData.phoneCountryCode = phoneNumberData.countryCode
          formData.phoneCountryCallingCode = phoneNumberData.countryCallingCode
          formData.phoneNumber = phoneNumberData.phoneNumber
          resolve(formData)
          return
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-form-item-control {
  line-height: 32px;
}
div ::v-deep .ant-advanced-search-form {
  padding-top: 0;
}
.emergency {
  font-weight: 500;
  font-size: 16px;
  color: #000;
}
.phone-number-extension {
  padding-left: 0 !important;
  margin-left: -3px;
}
.phone-number-extension-input {
  height: 40px;
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}
.phone-number-extension ::v-deep .ant-form-item-label > label::after {
  content: '';
}
/deep/ .ant-card-body {
  padding: 10px 20px 20px 20px ;
}
//
/deep/.phone-number-extension-input {
  height: 32px;
}
</style>
